import CashiersTable from "./cashiers-table";

export default CashiersTable;
